import { WANTABLE_API_BASE_URL } from "@wantable/Config"

export const subscribeToNewsletter = async (email: string) => {
  try {
    const response = await fetch(
      `${WANTABLE_API_BASE_URL}/users/mailing_list_subscribe`,
      {
        method: "POST",
        body: JSON.stringify({ email }),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return await response.json();
  } catch (error) {
    return error;
  }
};
